export default __webpack_public_path__ + "static/about-banner-769d59ad80b58c83f4a08f8ab4122642.png";